"use client";

import { useEffect } from "react";

import { trackEvent } from "@/utils/trackEvent";

export function WindowFocusTracker() {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        trackEvent("window_focused", {});
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return null;
}
